import { Alert, Box } from "@mui/material";
import {
	BooleanInput,
	DeleteButton,
	Edit,
	required,
	SaveButton,
	SelectArrayInput,
	SelectInput,
	SimpleForm,
	TextInput,
	Toolbar,
	useRecordContext,
} from "react-admin";
import { RestoreButton } from "@/components/RestoreButton";

const AppEditToolbar = () => {
	const record = useRecordContext();

	return (
		<Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
			<SaveButton />
			<Box>
				{record?.deletedAt && <RestoreButton resource="apps" />}
				<DeleteButton />
			</Box>
		</Toolbar>
	);
};

const DeletedAlert = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			This app was deleted on {new Date(record.deletedAt).toLocaleDateString()}.
			You can restore it using the Restore button below.
		</Alert>
	);
};

export const AppEdit = () => (
	<Edit>
		<DeletedAlert />
		<SimpleForm toolbar={<AppEditToolbar />}>
			<TextInput source="id" disabled />
			<TextInput source="name" validate={required()} fullWidth />
			<TextInput source="ownerId" disabled />
			<TextInput source="ownerEmail" disabled label="Owner Email" />
			<BooleanInput source="active" />
			<BooleanInput source="testMode" label="Test Mode" />
			<SelectInput
				source="attributionMode"
				choices={[
					{ id: "code", name: "Code" },
					{ id: "window", name: "Window" },
				]}
				validate={required()}
			/>
			<SelectInput
				source="attestationProvider"
				label="Attestation Provider"
				choices={[
					{ id: "none", name: "None" },
					{ id: "firebase", name: "Firebase" },
					{ id: "apple", name: "Apple" },
					{ id: "google", name: "Google" },
				]}
				validate={required()}
			/>
			<SelectInput
				source="iapProvider"
				label="IAP Provider"
				choices={[
					{ id: "none", name: "None" },
					{ id: "revenuecat", name: "RevenueCat" },
					{ id: "apple", name: "Apple" },
					{ id: "google", name: "Google" },
				]}
				validate={required()}
			/>
			<SelectArrayInput
				source="platforms"
				choices={[
					{ id: "ios", name: "iOS" },
					{ id: "android", name: "Android" },
					{ id: "any", name: "Any" },
				]}
			/>
			<TextInput
				source="allowedCorsOrigins"
				fullWidth
				helperText="Comma-separated list of allowed CORS origins"
			/>
			<TextInput source="stripeAccountId" disabled label="Stripe Account ID" />
		</SimpleForm>
	</Edit>
);
